import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import headerInfluencerImage from '../../assets/images/header-influencer.svg';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { Loading } from '../../components/Loading';
import { Notify } from '../../components/Notify';
import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { IInfluencer } from './interfaces';
import styles from './style.module.css';

export function ChooseInfluencer() {
  const { client, player, loadingAuth, getClientByAliasAndPlayer } = useAuth();
  const navigate = useNavigate();

  const [influencersList, setInfluencersList] = useState<Array<IInfluencer>>();
  const [loadingInfluencer, setLoadingInfluencer] = useState<boolean>(false);
  const [influencerSelected, setInfluencerSelected] = useState<string>();
  const imageDefault =
    'https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/playerProfile%2Favatar.png?alt=media&token=4960beef-5a9d-4cf1-9ffa-3a20136a3d1d';

  useEffect(() => {
    getInitial();
  }, []);

  const getInitial = async () => {
    await getInfluencersList();
  };

  const getInfluencersList = async () => {
    try {
      const parameters = {
        searchFunctionality: 'getInfluencersList',
        userType: 'player',
        clientId: client.id,
      };
      const { data } = await api.post('/search', parameters);
      if (data.success) setInfluencersList(data.data);
    } catch (error) {
      console.log('error ao trazer lista de influencers');
    }
  };

  const updatePlayer = async () => {
    setLoadingInfluencer(true);
    const parameters = {
      updateFunctionality: 'updateSelectedInfluencer',
      userType: 'player',
      playerId: player.id,
      influencerId: influencerSelected,
      clientId: client.id,
    };

    try {
      const { data } = await api.post(`/update`, parameters);

      if (data.success) {
        getClientByAliasAndPlayer();
        Notify(data.message, 'success');
        setTimeout(() => navigate(routes.HOME), 3000);
      }
      setLoadingInfluencer(false);
    } catch (error) {
      setLoadingInfluencer(false);
      Notify('Erro ao inclui-lo na equipe!', 'error');
      console.log('error no update do influencer', error);
    }
  };

  if (loadingAuth) {
    return <Loading />;
  }

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Escolher equipe'}
      />
      <div className="container">
        {/* Header SVG */}
        <div className="mb-3">
          {/* Header SVG Desktop */}
          <div className="d-none d-sm-flex flex-column align-items-center">
            <img className="img-fluid" src={headerInfluencerImage} alt="" />
            <div className={styles.wrapperLogoHeader}>
              <div className={styles.logoHeader}>
                <img
                  // src="https://arboreengenharia.com.br/wp-content/uploads/2022/01/LOGO-menuV2.png"
                  src={client.logoURL ? client.logoURL : ''}
                  // src="https://www.consominas.com.br/wp-content/uploads/2020/12/logo_mrv_engenharia.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* Fim Header SVG Desktop */}

          {/* Header SVG Mobile */}
          <div className="d-flex d-md-none flex-column align-items-center">
            <img className="img-fluid" src={headerInfluencerImage} alt="" />
            <img
              // src="https://arboreengenharia.com.br/wp-content/uploads/2022/01/LOGO-menuV2.png"
              src={client.logoURL ? client.logoURL : ''}
              // src="https://www.consominas.com.br/wp-content/uploads/2020/12/logo_mrv_engenharia.png"
              alt=""
              className="mt-4"
              width={200}
            />
          </div>
          {/* Fim Header SVG Mobile */}

          <div className="d-flex flex-column align-items-center mt-4">
            <span className="fs-3 mb-3">Escolha uma equipe</span>
            <p className="text-center text-black-50">
              Faça parte de uma equipe e comece <br />a vender mais!
            </p>
          </div>
        </div>

        {/* Fim Header SVG */}

        <div className="row">
          {influencersList &&
            influencersList?.length > 0 &&
            influencersList.map((influencer, index) => {
              return (
                <div key={index} className="col-sm-12 col-md-3">
                  <div className="mb-3 mb-md-0">
                    <Card>
                      <div className="d-flex justify-content-center">
                        <div className={styles.cover}>
                          <img
                            src={
                              influencer.photoURL
                                ? influencer.photoURL
                                : imageDefault
                            }
                            alt="Imagem de perfil"
                          />
                        </div>
                      </div>
                      <div className="d-flex flex-column align-items-center my-3">
                        <p
                          className="m-0 d-inline-block text-truncate text-black-50"
                          style={{ maxWidth: '100%' }}
                        >
                          <i className="material-icons-outlined float-start text-primary tiny me-2">
                            group
                          </i>
                          Equipe
                        </p>
                        <span className="fs-4 text-center">
                          {influencer.name}
                        </span>
                      </div>
                      <div className="d-grid">
                        <Button
                          icon={
                            influencer.id === influencerSelected ||
                            (influencer.id === player.influencerId &&
                              !influencerSelected)
                              ? 'check'
                              : 'add'
                          }
                          text={
                            influencer.id === influencerSelected ||
                            (influencer.id === player.influencerId &&
                              !influencerSelected)
                              ? 'Selecionado'
                              : 'Selecionar'
                          }
                          color={
                            influencer.id === influencerSelected ||
                            (influencer.id === player.influencerId &&
                              !influencerSelected)
                              ? 'primary'
                              : 'flat'
                          }
                          onClick={() => {
                            setInfluencerSelected(influencer.id);
                          }}
                          disabled={influencerSelected || player.influencerId}
                        />
                      </div>
                    </Card>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="d-flex flex-column align-items-center mt-4">
          <Button
            disabled={
              !influencerSelected ||
              influencerSelected === '' ||
              loadingInfluencer
            }
            text="Confirmar escolha"
            color="primary"
            onClick={() => updatePlayer()}
          />
        </div>
      </div>
    </>
  );
}
